export default function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/createStyles/createStyles.js
// module id = 1716
// module chunks = 121